module.exports = __webpack_public_path__ + "static/media/motolabirinto.fd312c0c.gif";